<template>
    <div class="page">
        <van-icon name="arrow-left" class="return" size="28" @click="goBack" />
        <div class="logo">
            <img src="../assets/images/logo/logo1.png" alt="" />
        </div>
        <div class="sub-logo"></div>
        <div class="info">
            <img src="../assets/images/service/bg2.jpg" class="banner" alt="" style="width: 100%;
		max-width: 100%;
		margin: 0 auto;
		display: block;
		box-sizing: border-box;" />
            <!-- 白色边框 -->
            <div class="success-container" v-if="success">
                <div class="success-title">签到成功</div>
                <div class="pending-min-btn">请您移步武汉富万达嘉华酒店（三楼大宴会厅）入座参会！</div>

                <div class="success-content">
                    <div>尊敬的 <span class="highlight">{{ name }}</span> 您已成功签到！</div>
                    <div class="seat-number">
                        <div>您的座位号是：</div>
                        <div style="color: #2196F3;">{{ seatNumber }}</div>
                    </div>
                    <!-- <div style="color: #2196F3;" v-if="restaurant">您的餐厅是：{{ restaurant }}</div> -->
                </div>
            </div>
            <!-- 输入手机号查询 -->
            <div class="success-container" v-else>
                <div class="input-container">
                    <input v-model="mobile" type="tel" placeholder="请输入手机号" style="height: 40px;" />
                </div>
                <button class="pending-btn" @click="querySeat">签到</button>
            </div>
        </div>

        <div class="apply" @click="goBack" v-if="success">查看更多</div>
    </div>
</template>

<script setup>
import { showToast, showSuccessToast } from "vant";
import { ref } from "vue";
import { signIn } from "../api/user";

import { useRouter } from 'vue-router';

const router = useRouter();
const goBack = () => {
    router.push({
        path: "/service",
    });
};

// 是否成功
const success = ref(false);
// 手机号
const mobile = ref("");
// 姓名
const name = ref("");
// 座位号
const seatNumber = ref("");
// 餐厅
const restaurant = ref("");
const querySeat = async () => {
    const res = await signIn({ mobile: mobile.value });
    if (res.code === 200) {
        name.value = res.data.name;
        seatNumber.value = res.data.seatNum || "未分配";
        restaurant.value = res.data.restaurant || "未分配";
        success.value = true;
        showSuccessToast("签到成功");
    } else {
        success.value = false;
        showToast(res.msg);
    }
};
</script>

<style scoped>
.return {
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
}

.page {
    width: 100vw;
    height: 100vh;
    background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
    background-size: cover;
}

.logo img {
	width: 40%;
	height: auto;
	display: block;
    margin: auto;
	padding: 20px 0;
	/* margin-left: 10%; */
}

.sub-logo {
    width: 90%;
    height: 70px;
    background: url("../assets/images/logo/text.png") no-repeat center center;
    background-size: contain;
    margin: auto;
}


.info {
    width: 82%;
    margin: auto;
    border-radius: 15px;
    margin-top: 20px;
    padding: 20px 10px;
    /* background-color: rgb(2 174 250 / 20%); */
    /* background: linear-gradient(180deg, #00b4ff, rgba(0, 123, 255, 0.3)); */
    box-sizing: border-box;
    overflow: hidden;


}

.info .banner {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    display: block;
    box-sizing: border-box;
     border-radius: 10px 10px 0 0;
}

.text {
    color: #ffffff;
    text-align: center;
    margin: 5px 0;
}

.apply {
    width: 150px;
    height: 40px;
    /* height: auto; */
    background-image: url("../assets/images/apply.png");
    /* 替换为你的背景图片路径 */
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: auto;
    margin-top: 20px;
    color: #071beb;
    font-weight: bold;


}

.success-container {
    background: white;
    border-radius: 0 0 20px 20px;
    padding: 10px 10px;
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);


}

.success-container .input-container {
    margin-bottom: 10px;
}

.success-title {
    font-size: 23px;
    text-align: center;
    font-weight: bold;
    margin-bottom: 10px;
}

.success-content {
    font-size: 16px;
    line-height: 1.8;
}

.highlight {
    color: #2196F3;
    font-weight: bold;
}

.seat-number {
    align-items: center;
    margin-top: 10px;
}

.pending-btn {
    width: 150px;
    height: 40px;
    background-image: url("../assets/images/apply.png");
    background-size: cover;
    background-position: center;
    border: none;
    color: #071beb;
    padding: 5px 20px;
    border-radius: 15px;
    font-size: 15px;
    cursor: pointer;
}

input {
    width: 100%;
    height: 28px;
    background: #ffffff00;
    border: none;
    border: 1px solid #02aefa;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
}

.pending-min-btn {
    background: #2196F3;
    color: white;
    border: none;
    padding: 5px;
    border-radius: 15px;
    font-size: 16px;
    cursor: pointer;
    margin-bottom: 10px;
}
</style>
